import React, { useCallback, useEffect, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { getDataFromServer } from '../../utils/apiBase';
import moment from 'moment';
import toast from 'react-hot-toast';
import ContextHelper from '../../ContextHooks/ContextHelper';
import CommonTable from '../table/CommonTable';
import logoInvoice from '../../Assets/sid.png';

function BillingReports({ handleOpen }) {
  const { currentUser } = ContextHelper();
  const [patientBilling, setPatientBilling] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPatientData();
  }, []);

  const fetchPatientData = async () => {
    const ApiUrl = 'getBills';

    const params = {
      end_point: ApiUrl,
      params: { token: currentUser?.token },
      call_back: handleResponse,
      props: '',
    };

    try {
      await getDataFromServer(params);
    } catch (error) {
      console.error('Error fetching patient data:', error);
      toast.error('Failed to fetch patient data?.');
      setLoading(false);
    }
  };

  const handleResponse = (res) => {
    setLoading(false);
    if (res.status === 'success') {
      setPatientBilling(res.response);
    } else {
      toast.error(res.message || 'Failed to fetch patients.');
    }
  };
  const renderTime = useCallback((value, row) => <span>{moment(value).format('DD-MMM-YYYY')}</span>, []);

  const renderTotal = useCallback((value, row) => {
    const total = row.studies?.reduce((acc, study) => {
      const price = parseFloat(study.unitPrice) || 0;
      return acc + price;
    }, 0);

    const discounts = row.studies?.map((study) => parseFloat(study.discount) || 0) || [];
    let finalTotal = total;

    row.studies?.forEach((study, index) => {
      if (study.discount) {
        const studyPrice = parseFloat(study.unitPrice) || 0;
        const discountAmount = (studyPrice * parseFloat(study.discount)) / 100;
        finalTotal -= discountAmount;
      }
    });

    return <span>{finalTotal.toFixed(2)}</span>;
  }, []);

  const handlePrintBill = (value, row) => {
    const data = row;

    const calculateTotal = () => {
      return data?.studies
        .reduce((total, study) => {
          const amount = parseFloat(study.unitPrice) || 0;
          const discount = parseFloat(study.discount) || 0;
          const discountAmount = (amount * discount) / 100;
          return total + (amount - discountAmount);
        }, 0)
        .toFixed(2);
    };

    const billContent = `
      <div style="max-width: 800px; margin: 0 auto; font-family: Arial, sans-serif; font-size: 14px; color: #000;">
        <div style="text-align: center;">
          <img src="${logoInvoice}" alt="Siddharth Logo" style="width: 500px;" />
          <h1 style="font-size: 22px; font-weight: bold; text-align: center; border-bottom: 1px solid #000;">INVOICE</h1>
          <h2 style="font-size: 18px; font-weight: bold; text-align: center;">${currentUser?.name}</h2>
        </div>
    
        <div style="width: 100%; border-bottom: 2px solid #000; margin-bottom: 20px;">
          <div style="display: flex; justify-content: space-between; width: 100%;">
            <div style="width: 50%;">
              <div style="display: flex; margin-bottom: 10px;">
                <span style="text-align: left; width: 30%;">Patient No.</span>
                <span style="width: 10%; text-align: center;">:</span>
                <strong style="width: 60%;">${data?.patientID}</strong>
              </div>
        
              <div style="display: flex; margin-bottom: 10px;">
                <span style="text-align: left; width: 30%;">Patient</span>
                <span style="width: 10%; text-align: center;">:</span>
                <strong style="width: 60%;">${data?.patientName} (${data?.patientAge} | ${data?.patientGender})</strong>
              </div>
        
              <div style="display: flex; margin-bottom: 10px;">
                <span style="text-align: left; width: 30%;">Mobile</span>
                <span style="width: 10%; text-align: center;">:</span>
                <span style="width: 60%;">${data?.mobileNumber}</span>
              </div>
        
              <div style="display: flex; margin-bottom: 10px;">
                <span style="text-align: left; width: 30%;">Referred by</span>
                <span style="width: 10%; text-align: center;">:</span>
                <span style="width: 60%;">${data?.referringPhysicianName}</span>
              </div>
            </div>
        
            <div style="width: 50%;">
              <div style="display: flex; margin-bottom: 10px;">
                <span style="text-align: left; width: 30%;">Bill No / Lab No</span>
                <span style="width: 10%; text-align: center;">:</span>
                <strong style="width: 60%;">${data?.billNumber}</strong>
              </div>
        
              <div style="display: flex; margin-bottom: 10px;">
                <span style="text-align: left; width: 30%;">Visit Date</span>
                <span style="width: 10%; text-align: center;">:</span>
                <span style="width: 60%;">${data?.regDate}</span>
              </div>
        
              <div style="display: flex; margin-bottom: 10px;">
                <span style="text-align: left; width: 30%;">Print Date</span>
                <span style="width: 10%; text-align: center;">:</span>
                <span style="width: 60%;">${data?.dateOfBilling}</span>
              </div>
        
              <div style="display: flex; margin-bottom: 10px;">
                <span style="text-align: left; width: 30%;">Bill User</span>
                <span style="width: 10%; text-align: center;">:</span>
                <span style="width: 60%;">${currentUser?.name}</span>
              </div>
            </div>
          </div>
        </div>
        
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
          <thead>
            <tr>
              <th style="padding: 10px; text-align: left; border-bottom: 1px solid #000;">SI.No</th>
              <th style="padding: 10px; text-align: left; border-bottom: 1px solid #000;">InvestId</th>
              <th style="padding: 10px; text-align: left; border-bottom: 1px solid #000;">Description</th>
              <th style="padding: 10px; text-align: right; border-bottom: 1px solid #000;">Amount</th>
              ${
                data?.studies.some((s) => s.discount)
                  ? '<th style="padding: 10px; text-align: right; border-bottom: 1px solid #000;">Discount</th>'
                  : ''
              }
              ${
                data?.studies.some((s) => s.discount)
                  ? '<th style="padding: 10px; text-align: right; border-bottom: 1px solid #000;">Net Amount</th>'
                  : ''
              }
            </tr>
          </thead>
          <tbody>
            ${data?.studies
              .map((study, i) => {
                const amount = parseFloat(study.unitPrice) || 0;
                const discount = parseFloat(study.discount) || 0;
                const discountAmount = (amount * discount) / 100;
                const netAmount = amount - discountAmount;

                return `
                  <tr>
                    <td style="padding: 10px; border-bottom: 1px solid #000; text-align: left;">${i + 1}</td>
                    <td style="padding: 10px; border-bottom: 1px solid #000; text-align: left;">${study.studyId}</td>
                    <td style="padding: 10px; border-bottom: 1px solid #000; text-align: left;">${
                      study.studyDescription
                    }</td>
                    <td style="padding: 10px; border-bottom: 1px solid #000; text-align: right;">${amount.toFixed(
                      2
                    )}</td>
                    ${
                      discount
                        ? `<td style="padding: 10px; border-bottom: 1px solid #000; text-align: right;">${discount}%</td>`
                        : ''
                    }
                    ${
                      discount
                        ? `<td style="padding: 10px; border-bottom: 1px solid #000; text-align: right;">${netAmount.toFixed(
                            2
                          )}</td>`
                        : ''
                    }
                  </tr>`;
              })
              .join('')}
          </tbody>
        </table>
    
        <div style="display: flex; justify-content: flex-end;">
          <table style="border-collapse: collapse;">
            <tbody>
              <tr>
                <td style="font-weight: bold; padding-bottom: 10px; padding-right: 20px;">Total Amount :</td>
                <td style="font-weight: bold; text-align: right; padding-bottom: 10px;">${calculateTotal()}</td>
              </tr>
              <tr>
                <td style="font-weight: bold; padding-bottom: 10px; padding-right: 20px;">Amount Received :</td>
                <td style="font-weight: bold; text-align: right; padding-bottom: 10px;">${
                  data?.payMode !== 'Credit Amount' ? calculateTotal() : '0.00'
                }</td>
              </tr>
              <tr>
                <td style="font-weight: bold; padding-bottom: 10px; padding-right: 20px;">Credit Amount :</td>
                <td style="font-weight: bold; text-align: right; padding-bottom: 10px;">${
                  data?.payMode === 'Credit Amount' ? calculateTotal() : '0.00'
                }</td>
              </tr>
            </tbody>
          </table>
        </div>
    
        <div style="text-decoration: underline; border-top: 2px solid #000; font-style: italic; margin-bottom: 20px;">
          Payment Details:
        </div>
        <div style="display: flex; justify-content: space-between;">
          <div style="display: flex; flex-direction: column;">
            <strong>Paid Date</strong>
            <strong>${data?.dateOfBilling}</strong>
          </div>
          <div style="display: flex; flex-direction: column;">
            <strong>Paid Amount</strong>
            <strong>${calculateTotal()}</strong>
          </div>
          <div style="display: flex; flex-direction: column;">
            <strong>Paid Mode</strong>
            <strong>${data?.payMode}</strong>
          </div>
        </div>
    
        <div style="margin-top: 20px; margin-bottom: 20px; line-height: 1.8;">
          <p><strong>Note: Reports will be dispatched during working hours. Report will take 6 hrs to dispatch from the time of scan completion. Emergency cases will be dispatched in 2 hrs from the time of scan completion.</strong></p>
          <p style="margin-top: 20px; margin-bottom: 20px;"><strong>For Siddhart MRI and CT SCAN Services Private Limited.</strong></p>
          <p><strong>Authorized Signatory</strong></p>
          <p><strong>Corp. Office:</strong> 2nd Floor 4-A, Green Nagar, Durgapura, Jaipur (Raj.) - 302018 T: 0141-4917068, 9782427272</p>
        </div>
      </div>
    `;

    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.write('<html><head><title>Print</title>');
    printWindow.document.write('<style>body { font-family: Arial, sans-serif; }</style>');
    printWindow.document.write('</head><body>');
    printWindow.document.write(billContent);
    printWindow.document.write('</body></html>');
    printWindow.document.close();

    printWindow.onload = function () {
      printWindow.print();
      printWindow.close();
    };
  };
  const renderBilling = useCallback((value, row) => {
    return (
      <div className="text-nowrap">
        <Button className="login-btn base-color-bg text-white" onClick={() => handlePrintBill(value, row)}>
          Print Bill
        </Button>
      </div>
    );
  }, []);

  const renderStudy = useCallback((value, row) => {
    return <span>{row.studies?.map((i) => i?.study).join(', ')}</span>;
  }, []);

  const renderStudyDesc = useCallback((value, row) => {
    return <span>{row.studies?.map((i) => i?.studyDescription).join(', ')}</span>;
  }, []);

  const renderUnitPrice = useCallback((value, row) => {
    return <span>{row.studies?.map((i) => i?.unitPrice).join(', ')}</span>;
  }, []);

  const renderDiscount = useCallback((value, row) => {
    return (
      <span>
        {row?.studies
          ?.map((i) => (i?.discount ? `${i?.discount}%` : ''))
          .filter(Boolean)
          .join(', ')}
      </span>
    );
  }, []);

  const renderRemarks = useCallback((value, row) => {
    return (
      <span className="text_truncate" title={value}>
        {value}
      </span>
    );
  }, []);

  const renderScheme = useCallback((value, row) => {
    return (
      <div>
        <span className="text-nowrap">{value}</span>
        <p>{row.schemeCode}</p>
      </div>
    );
  }, []);

  const columns = [
    { accessor: 'patientName', label: 'Patient Name' },
    { accessor: 'mobileNumber', label: 'Mobile Number' },
    { accessor: 'tenantType', label: 'Tenant' },
    { accessor: 'studies_names', label: 'Study', render: renderStudy },
    { accessor: 'studies_desc', label: 'Study Description', render: renderStudyDesc },
    { accessor: 'referringPhysicianName', label: 'Referring Physician Name' },
    { accessor: 'studies_price', label: 'Unit Price', render: renderUnitPrice },
    { accessor: 'studies_discount', label: 'Discount', render: renderDiscount },
    { accessor: 'unitPrice', label: 'Total', render: renderTotal },
    { accessor: 'dateOfBilling', label: 'Date of Billing', render: renderTime },
    // { accessor: 'scheme', label: 'Scheme', render: renderScheme },
    // { accessor: 'remarks', label: 'Remarks', render: renderRemarks },
    { accessor: 'billNumber', label: 'Billing', render: renderBilling },
  ];

  return (
    <Container fluid className="px-0">
      <div className="bg-white p-4 min-vh-100 shadow-sm">
        <div className="d-flex justify-content-between">
          <h3 className="base-color mb-2">Billing Details</h3>
          <div>
            <Button variant="" className="login-btn fs-15 base-color-bg text-white fw-semibold" onClick={handleOpen}>
              Patient Billing
            </Button>
          </div>
        </div>

        <CommonTable data={patientBilling} columns={columns} loading={loading} />
      </div>
    </Container>
  );
}

export default BillingReports;
